import * as Handlebars from 'handlebars/dist/handlebars.js';
import * as deloitteCookies from 'js-cookie/src/js.cookie.js';
import * as gfunctions from '../../../js/generalFunctions';
/* eslint-disable */

CCL.pdpCard = {
  autoload: [
    ['toggleDepartureTime', $('.departure-link').length > 0],
    ['btnClick', $('#calendarModal').length > 0],
    ['customClickEvents', $('#calendarModal').length > 0],
    ['toggleBookingDropdown', $('body').length > 0],
    ['toggleWheelChair', $('.wheel-chair0').length > 0],
    ['toggleSpecialService', $('.wheel-chair1').length > 0],
    ['pdpGetSelected', $('.pdp-add-to-cart-btn').length > 0],
    ['pdpReadError', $('.general-add-to-cart-btn').length > 0],
    ['addedToCartExperience', $('.pdp-conflict-check').length > 0],
    ['addedToCartExperienceForCarousel', $('body').length > 0],
    ['onCheckboxCheck', $('.custom-control.custom-checkbox.stateroom-check').length > 0],
    ['scrollToReviews', $('.c-pdp-card').length > 0],
    ['addStickyToAddToCart', $('.c-pdp-card').length > 0],
    ['ajaxForRecentView', $('.c-pdp-card').length > 0],
    ['toReviews', $('.c-product-card').length > 0],
    ['calendarModalEvents', $('#calendarModal').length > 0],
  ],
  updatedIdArray: [],
  jsonData: {},
  currentUserId: '',
  currentResHoldId: '',
  productId: '',
  dataObj: {},
  calendarError: false,
  isCruisePass: false,

  ajaxForRecentView() {
    const productId = $('body').find('.c-pdp-card').data('productcardid');
    if (productId && productId !== '') {
      const token = $('#csrfSessionToken').data('csrf');
      $.ajax({
        type: 'GET',
        url: `/shop/update/recentlyViewedProducts?productId=${productId}`,
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      }).done((response) => {
        console.log('Sent prod id of recently viewed');
      }).fail(() => {
        gfunctions.hideLoader();
        console.log('Error - prod id of recently viewed');
      });
    }
  },

  addedToCartExperienceForCarousel() {
    $('.pdp-carousel-atc').click((e) => {
      if ($(e.currentTarget).hasClass('conflict-check-from-carousel')) {
        $('#addToCartSuccessModal .close').addClass('check-pdp-conflicts').addClass('reload-carousel');
        if (e.type === 'click' || e.keyCode === 13) {
          this.dataObj.productCode = $('body').find('.c-pdp-card .btn-red.general-add-to-cart-btn').data('productcode');
        }
      } else {
        $('#addToCartSuccessModal .close').addClass('reload-carousel');
      }
    });

    $('body').on('click keypress', '.reload-carousel', (e) => {
      const token = $('#csrfSessionToken').data('csrf');
      const productId = $('body').find('.c-pdp-card .btn-red.general-add-to-cart-btn').data('productcode');
      const componentUid = $('body').find('.pdp-carousel #componentUid').data('componentuid');
      $.ajax({
        type: 'GET',
        url: `/shop/view/CCLProductCarouselComponentController?componentUid=${componentUid}&productId=${productId}`,
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      }).done((response) => {
        gfunctions.hideLoader();
        $('body').find('.pdp-carousel').replaceWith(response);
        $('body').find('.pdp-carousel .empty-placeholder').hide();
        $('body').find('.pdp-carousel .product-carousel-container').show();

        CCL.cruiseManager.carouselFunctions();

      }).fail(() => {
        gfunctions.hideLoader();
        console.log('error while fetching data');
      });
    });
  },

  addedToCartExperience() {
    $('.pdp-conflict-check').click((e) => {
      $('#addToCartSuccessModal .close').addClass('check-pdp-conflicts');
      //  $('body').on('click keypress', '.pdp-conflict-check', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        this.dataObj.productCode = $(e.currentTarget).data('productcode');
      }
    });

    $('body').on('click keypress', '.check-pdp-conflicts', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        $('#clpAddToCartModal #clpAddToCartModalContent').empty();
        this.checkPdpConflicts(this.dataObj);
      }
    });
  },

  checkPdpConflicts(ajaxDataObj) {
    gfunctions.showLoader();

    const token = $('#csrfSessionToken').data('csrf');
    let ajaxUrl = '';
    let ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/clp-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }

    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(ajaxDataObj)
    }).done((response) => {
      gfunctions.hideLoader();
      this.showPdpConflicts(response);
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },

  showPdpConflicts(response) {
    $.each(response.bookingInformation, (index, value) => {
      if (response.productType === 'SF') {
        $($(`#${value.bookingId}`)[0])[0].dataset.qty = response.bookingInformation[index].purchasedQuantity;
        if ($('.restrict-quantity').length > 0) {
          $('.restrict-quantity input .quantity-input-1').val('1');
          $('.alcohol-error-msg').hide();
        }
      }
      if (response.globalErrorMessage && response.globalErrorMessage !== '') {
        $($(`#${value.bookingId}`)[0].parentElement).find('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg').addClass('gray');
        if ($('.restrict-quantity').length > 0) {
          $('.restrict-quantity').hide();
          $('.terms-conditions-btn').attr('disabled', 'disabled');
        }
        if ($('.static-qty').length > 0) {
          $('.static-qty').hide();
        }
        $($(`#${value.bookingId}`)[0].parentElement).addClass('stateroom-disabled');
        $(`#${value.bookingId}`)[0].checked = false;
        $(`#${value.bookingId}`)[0].disabled = true;
        $($(`#${value.bookingId}`)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
        $(`.error-msg-${value.bookingId} span`).html('');
        if (index === 0) {
          $(`.inner-pdp-error-msg span`).html('');
          $(`.inner-pdp-error-msg`).removeAttr('tabindex');
          $(`.pdp-error-msg span`).html('');
          $(`.pdp-error-msg span`).removeAttr('tabindex');
          $('.pdp-add-to-cart-btn').before(`
            <div class="inner-pdp-error-msg" role="alert" aria-live="assertive">
            <span>
                <div class="content">${response.globalErrorMessage}</div>
            </span>
            </div>`);
        }
        $('.pdp-add-to-cart-btn').attr('disabled', 'disabled');
        $('.stateroom-check .booking-toggle').removeAttr('tabindex');
      } else {
        if (value.errorMessage) {
          const bookingId = $(`#${value.bookingId}`)[0].id;
          $(`.error-msg-${value.bookingId} span`).html(value.errorMessage);
          $($(`#${value.bookingId}`)[0].parentElement).addClass('stateroom-disabled');
          $($(`#${value.bookingId}`)[0].parentElement).find('.booking-toggle').removeAttr('tabindex');
          $($(`#${value.bookingId}`)[0].parentElement).find('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg').addClass('gray');
          $($(`#${value.bookingId}`)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
          if (response.guestSelectable || response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP') {
            $.each(value.guestInformation, function (guestIndex, guestValue) {
              let guestCheckBox = '';
              if (response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP') {
                guestCheckBox = $(`#${guestValue.guestId}`);
              } else {
                guestCheckBox = $(`#${guestValue.guestId}`);
              }
              if (guestCheckBox.length > 0) {
                $(guestCheckBox)[0].checked = false;
              }
            });
          }
          $(`#${value.bookingId}`)[0].checked = false;
          $(`#${value.bookingId}`)[0].disabled = true;
        } else {
          // $(`#${value.bookingId}`)[0].checked = true;
          // $(`#${value.bookingId}`).attr('checked', 'checked');
          $(`#${value.bookingId}`).removeAttr('disabled');
        }
        if (value.guestInformation.length) {
          $.each(value.guestInformation, (guestIndex, guestValue) => {
            if (guestValue.errorText && !value.errorMessage && response.guestSelectable) {
              $(`.error-msg-${guestValue.guestId} span`).html(guestValue.errorText);
              $($(`#${guestValue.guestId}`)[0].parentElement).addClass('stateroom-disabled');
              $($(`#${guestValue.guestId}`)[0].parentElement).addClass('div-disabled');
              $(`#${guestValue.guestId}`)[0].checked = false;
              $(`#${guestValue.guestId}`)[0].disabled = true;
              //  $($(`#${value.bookingId}`)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
            } else if (!guestValue.errorText && !value.errorMessage && (response.productType === 'SF' || response.productType === 'SFP' || response.productType === 'SFAP')) {
              // const bookingId = $(`#${value.bookingId}`)[0].id;
              // $(`#${bookingId + guestValue.guestId}`).removeAttr('disabled');

              if ($(`#${guestValue.guestId}`).length) {
                $(`#${guestValue.guestId}`)[0].disabled = false;
                $(`#${guestValue.guestId}`).removeAttr('disabled');
              }
            }
            if ((!guestValue.errorText || guestValue.errorText === '') && !(response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP')) {
              // $(`#${guestValue.guestId}`)[0].checked = true;
              // $(`#${guestValue.guestId}`).attr('checked', 'checked');
              if ($(`#${guestValue.guestId}`).length) {
                $(`#${guestValue.guestId}`)[0].disabled = false;
                $(`#${guestValue.guestId}`).removeAttr('disabled');
              }
            }
          });
          if (value.errorMessage) {
            $($(`#${value.bookingId}`)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
          } else if (!value.errorMessage && $($(`#${value.bookingId}`)[0].parentElement).find('.booking-dropdown .guests-check input:not(:checked)').length === $($(`#${value.bookingId}`)[0].parentElement).find('.booking-dropdown .guests-check input').length) {
            $(`#${value.bookingId}`)[0].checked = false;
            $(`#${value.bookingId}`).removeAttr('checked');
          }
        }
      }

    });
    this.pdpGetSelected();
  },

  pdpGetSelected() {
    gfunctions.pdpGetSelectedData();
  },

  pdpReadError() {
    setTimeout(() => {
      $('.common-pdp-error-message').attr({ "role": "alert", "aria-live": "assertive" });
      $('.inner-pdp-error-msg').attr({ "role": "alert", "aria-live": "assertive" });
      $('.error-message').attr({ "role": "alert", "aria-live": "assertive" });
    }, 2000);
  },

  onCheckboxCheck() {
    gfunctions.checkboxCheck();
  },


  btnClick() {
    $('body').on('click keypress', '.calendarOpenBtn', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        this.loadData(false, event);
      }
    });
  },

  calendarFocusable() {
    setTimeout(() => {
      const calendar = $('#calendarModalHtml');
      if (calendar.length > 0) {
        calendar.find('.price-box').attr('tabindex', '0');
      }
    }, 1000);
  },

  addStickyToAddToCart() {
    const $addToCartParentEle = $('.general-add-to-cart-btn').parent('.inner-wrap');
    if ($(window).outerWidth() <= 768) {
      $addToCartParentEle.css({ 'position': 'sticky', 'z-index': '1', 'bottom': '0' });
    }
    $(window).resize(() => {
      if ($(window).outerWidth() <= 768) {
        $addToCartParentEle.css({ 'position': 'sticky', 'z-index': '1', 'bottom': '0' });
      } else {
        $addToCartParentEle.css({ 'position': '', 'z-index': '', 'bottom': '' });
      }
    });
  },

  /**
  * Ajax request to load all the calendar data
  */
  loadData(userId, event) {
    gfunctions.showLoader();
    if (event) {
      this.productId = event.currentTarget.dataset.productcode;
    }
    const productId = this.productId ? this.productId : event.currentTarget.dataset.productcode;
    const uID = !userId ? 'default' : userId;
    let ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = `/_ui/responsive/ccl/assets/templates/c-spa-calendar/calendar-${uID}.json`;
    } else {
      ajaxUrl = `/spa/getAvailability/${uID}/${productId}`;
    }
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done((res) => {
      gfunctions.hideLoader();
      if (Object.keys(res).length !== 0 && res.constructor === Object && res.availability) {
        res.availability.currentUserId = res.availability.guestData.guestId;
        this.getData(res);
      } else if (res.error) {
        this.getData(res);
      }
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('Something went wrong');
    });
  },

  /**
  * get data from ajax request
  * @param {Object} data
  */
  getData(data) {
    if (data.availability) {
      $.each(data.availability.guestData.days, (index, value) => {
        value.hasSelectedTimings = false;
        value.treatments = value.treatments.sort((a, b) => {
          return new Date(a.time) - new Date(b.time);
        });
        $.each(value.treatments, (i, v) => {
          v.addedTocart = false;
        });
      });
      let end = Number(data.availability.timeSlots.endTime.split(':')[0]);
      if (end <= 21) {
        end += 2;
      } else if (end <= 22) {
        end += 1;
      }
      let starttime = `${data.availability.timeSlots.startTime.split(':')[0]}:00:00`;
      const endtime = `${end}:00:00`;
      const interval = '60';
      const timeslots = [starttime];
      while (starttime !== endtime) {
        starttime = this.getTimeslots(starttime, interval);
        timeslots.push(starttime);
      }
      const tmpTime = [];
      $.each(timeslots, (ind, val) => {
        tmpTime.push(this.tConv24(val));
      });
      data.availability.updatedSlots = tmpTime;

      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
        'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
      $.each(data.availability.guestData.days, (index, value) => {
        $.each(value.treatments, (i, v) => {
          // set hasSeletedTiming = true to show small green dot on day
          if (v.addedToCart) {
            value.hasSelectedTimings = true;
          }
        });
        const d = new Date(value.date);
        value.date = `${monthNames[d.getMonth()]} ${d.getDate()}`;
      });

      if (data.availability.bookingInformation && data.availability.isCruisePass) {
        data.availability.description = 'Select your guest to book now!';
        $.each(data.availability.bookingInformation, (bookingIndex, bookingValue) => {
          $.each(bookingValue.guestInformation, (guestIndex, guestValue) => {
            const guest = data.availability.guests.filter(x => x.id === guestValue.guestId)[0];
            if (guest) {
              guest.resHoldId = guestValue.resHoldId;
              guest.guestAdded = guestValue.guestAdded;
              guest.errorText = guestValue.errorText;
              if (guest.id === data.availability.guestData.guestId) {
                guest.selected = true;
              }
            }
          });
        });
      }
      if (window.location.pathname.includes('booked/home')) {
        data.availability.isCMPPage = true;
      } else {
        data.availability.isCMPPage = false;
      }
    }
    if (data.error) {
      this.calendarError = true;
    }
    if (data.availability && data.availability.isCruisePass) {
      this.isCruisePass = true;
    }
    this.jsonData = data;
    this.loadTemplate(data);
    // $('#calendarModal').modal();
    $('.loader').hide();
    $('#overlay').hide();
  },

  tConv24(time24) {
    let ts = time24;
    const H = +ts.substr(0, 2);
    let h = (H % 12) || 12;
    h = (h < 10) ? (`0${h}`) : h; // leading 0 at the left for 1 digit hours
    const ampm = H < 12 ? ' am' : ' pm';
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  },

  getTimeslots(time, minutes) {
    const date = new Date(new Date(`01/01/2019 ${time}`).getTime() + (minutes * 60000));
    const one = (date.getHours().toString().length === 1) ? `0${date.getHours()}` : date.getHours();
    const two = (date.getMinutes().toString().length === 1) ? `0${date.getMinutes()}` : date.getMinutes();
    const three = (date.getSeconds().toString().length === 1) ? `0${date.getSeconds()}` : date.getSeconds();
    const tempTime = `${one}:${two}:${three}`;

    return tempTime;
  },

  /**
  * ajax request to load HTML template for spa-calendar
  * @param {Object} data
  */
  loadTemplate(data) {
    $('#calendarModal .custom-modal').removeClass('cruise-custom-modal');
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/c-spa-calendar/calendar.html'
    }).done((response) => {
      const templateScript = Handlebars.compile(response);
      const html = templateScript(data);
      $('#calendarHtml').empty().append(html);
      // call all javascript event after above html load
      if (data.availability && data.availability.isCruisePass || data.error) {
        $('#calendarModal .custom-modal').addClass('cruise-custom-modal');
      }
      $('#calendarModal').modal();
      $('#calendarModal .header-content .close').addClass('ada-element-focus');
      setTimeout(() => {
        $('#calendarModal .header-content .close').focus();
      }, 800);

      setTimeout(() => {
        $('.spa-error').attr('role', 'alert');
        $('.spa-error').attr('aria-live', 'assertive');
      }, 3000);
      if ($('.header-success-text').length) {
        setTimeout(() => {
          $('.header-success-text').attr('role', 'alert');
          $('.header-success-text').attr('aria-live', 'assertive');
        }, 3000);
      }
      this.clickEvents();
      // load crousel on dynamic html
      this.loadCarousel();
      this.calendarFocusable();
      this.modalEvents();
    }).fail(() => {
      console.log('Something went wrong');
    });
  },

  getFocusableElements(modalEl, pos) {
    const tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled)';
    const firstFocusable = modalEl.find(tabbables).first();
    const lastFocusable = modalEl.find(tabbables).last();
    return (pos === 'last') ? lastFocusable : firstFocusable;
  },

  customClickEvents() {
    $('body').on('click keypress', '#calendarModalHtml .userSelect-item', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        $('#calendarMenu')[0].innerText = e.currentTarget.innerText;
        $('.dropdown-menu button').removeClass('active');
        e.currentTarget.className += ' active'; // Append active class to selected
        this.loadData(e.currentTarget.id);
        this.currentUserId = e.currentTarget.id;
      }
    });

    $('body').on('click keypress', '.mobile-day', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        $('.mobile-day').css('border', '1px solid #ECECEC');
        e.currentTarget.style.border = '2px solid #10559A';
        const dayVal = $(e.currentTarget.children)[0].innerText;
        $('.mobile-day').removeAttr('aria-label');
        $('.mobile-day a').removeAttr('aria-label');
        const dayCount = $('.mobile-day').length;
        const currentPos = ($(e.currentTarget)[0].id).substring(0, 1);
        $(e.currentTarget)[0].children[0].setAttribute('aria-live', 'assertive');
        $('.mobile-day').each((index) => {
          $(`#${index + 1}-mobile-day a`).attr('aria-label', `Day ${index + 1} of ${dayCount}`);
        });
        $(e.currentTarget)[0].children[0].setAttribute('aria-label', `${dayVal} selected ${dayVal} of ${dayCount}`);

        const position = $('.owl-carousel-7').find('.owl-item').eq(currentPos - 1);
        //this.getFocusableElements(position).focus();

        this.calendarFocusable();
      }
    });

    $('body').on('click keypress', '.header-atc-btn', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        this.cruisePassAddToCart(e);
      }
    });

    $('body').on('click keypress', '.price-box:not(.selected)', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        this.showSelected(e);
      }
      console.dir($($(`#1-day`)[0].previousElementSibling.previousElementSibling).attr('aria-label'));
    });
    $('body').on('click keypress', '.price-box .close', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        const { currentTarget } = e;
        e.preventDefault();
        e.stopPropagation();
        this.removeProduct(e);
        setTimeout(() => {
          $(`#${e.currentTarget.id}`).parent().focus();
        }, 600);
      }
    });

  },

  clickEvents() {
    const dayCount = $('.mobile-day').length;
    $('.mobile-day').each((index) => {
      $(`#${index + 1}-mobile-day a`).attr('aria-label', `Day ${index + 1} of ${dayCount}`);
    });
    $('.mobile-day:first-child a').attr('aria-label', `Day 1 selected day 1 of ${dayCount}`);
    setTimeout(() => {
      $('.mobile-day').each((index, element) => {
        if ($(element)[0].className == "mobile-day mobile-green-dot") {
          const MobLabel = $($(`#${index + 1}-mobile-day`)[0].firstElementChild).attr('aria-label');
          $($(`#${index + 1}-mobile-day`)[0].firstElementChild).attr('aria-label', `${MobLabel} has selected slots`);
        }
      });
    }, 1000);
    if (this.jsonData.availability) {
      this.currentUserId = this.jsonData.availability.guestData.guestId;
      $.each(this.jsonData.availability.guestData.days, (i, v) => {
        if (v.treatments.some((x) => x.addedTocart)) {
          $('#checkoutButton').removeAttr('disabled');
        }
      });
    }
    // update data again on close click

    $('.price-box').each((index, val) => {
      if (val.dataset.time) {
        const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const { duration, time } = val.dataset;
        const timeObj = new Date(time);
        const month = monthNames[timeObj.getMonth()]; // get month name from array
        // convert time into AM or PM format - Ex- 10:00 AM
        const appmTime = timeObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        $(val).find('.c-table-time').empty().html(appmTime.toLowerCase());
        const formattedDate = `${month} ${timeObj.getDate()}, ${timeObj.getFullYear()}`;
        // new Date(`${formattedDate} ${this.jsonData.availability.timeSlots.startTime}`);
        const dt1 = new Date(`${formattedDate} ${this.jsonData.availability.timeSlots.startTime.split(':')[0]}:00`); // Ex- November 29, 2018 8:00:00'
        const dt2 = timeObj;
        // Get difference in minutes between dates below
        const diff = ((dt2.getTime() - dt1.getTime()) / 1000) / 60;
        const timeDiff = Math.abs(Math.round(diff)); // rounding off values
        val.style.top = `${timeDiff + 1}px`;
        val.style.height = `${val.dataset.duration - 2}px`;
        val.title = `Time: ${appmTime} - Duration: ${duration} minutes`;
        if (Number(duration) < 45) {
          val.classList.add('small-price-box');
        }
        if (Number(duration) >= 90 && Number(duration) < 100) {
          val.style.padding = '22px 2px 10px 20px';
        }
        if (Number(duration) > 90) {
          val.style.padding = '36px 2px 10px 20px';
        }
      }
    });
  },

  cruisePassAddToCart(event) {
    const resHoldId = event.currentTarget.dataset.resholdid;
    const userId = event.currentTarget.id;
    let currentTreatment = [];
    $.each(this.jsonData.availability.guestData.days, (i, v) => {
      const temp = v.treatments.filter(x => x.resHoldId === resHoldId);
      if (temp.length) {
        currentTreatment = temp[0];
      }
    });
    const ajaxData = {
      CSRFToken: $('#csrfSessionToken').data('csrf'),
      resHoldId: resHoldId,
      spaGuestId: userId,
      quantity: 1,
      spaBundleEligible: currentTreatment.bundleEligible,
      spaProductPrice: currentTreatment.price.value,
      spaServiceDuration: currentTreatment.duration,
      productCodePost: currentTreatment.id,
      spaServiceDate: this.formatDate(currentTreatment.time),
      spaServiceTime: this.formatTime(currentTreatment.time)
    };
    const pageType = $('#pagetype').data('pagetype');
    ajaxData.pageType = pageType;
    if (pageType === 'CATEGORY') {
      ajaxData.productPosition = localStorage.getItem('productposition');
      ajaxData.pageNumber = localStorage.getItem('pageNumber');
      ajaxData.categoryName = localStorage.getItem('sascategorycode');
    }
    $.ajax({
      type: 'POST',
      url: '/shop/cart/add',
      data: ajaxData
    }).done((response) => {
      gfunctions.updateHeaderCartWidget(response);
      console.log('success');
      this.loadData(userId);
    }).fail(() => {
      //  gfunctions.hideLoader();
      gfunctions.showToast('#snackbar', 4000);
      console.log('Something went wrong on Add to Cart');
    });
  },

  removeProduct(event) {
    gfunctions.showLoader();
    const productId = $(event.currentTarget).data('productid');
    const token = $('#csrfSessionToken').data('csrf');
    const spaResHoldId = event.currentTarget.id;
    const dataObj = {
      productId,
      spaResHoldId
    };
    $.ajax({
      type: 'POST',
      url: '/shop/cart/entry/execute-action/REMOVE',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(dataObj)
    }).done((response) => {
      this.prepareData(event.currentTarget.parentElement.id, 'remove');
      $(event.currentTarget.parentElement).removeClass('selected');
      $(event.currentTarget).removeClass('.show-close').hide();
      gfunctions.hideLoader();
      this.loadData(this.currentUserId);
      console.log('SPA remove success');
    }).fail(() => {
      gfunctions.hideLoader();
      gfunctions.showToast('#snackbar', 4000);
      console.log('SPA remove error');
    });
  },

  /**
  * load owl-carousel options
  */
  loadCarousel() {
    if (!gfunctions.detectmob()) {
      if (this.jsonData.availability) {
        let extraWidth = 0;
        if (this.jsonData.availability.guestData.days.length === 2) {
          extraWidth = 150;
        } else if (this.jsonData.availability.guestData.days.length === 3) {
          extraWidth = 100;
        } else if (this.jsonData.availability.guestData.days.length === 4) {
          extraWidth = 30;
        }
        const divWidth = ((this.jsonData.availability.guestData.days.length * 2) * 100) + extraWidth;
        $('.modal-body-wrapper').css('width', `${divWidth}px`);
        $('.owl-carousel-7').owlCarousel({
          loop: false,
          nav: true,
          margin: 16,
          responsiveClass: true,
          autoWidth: true,
          mergeFit: false,
          dots: false,
          navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 3
            },
            1024: {
              items: 5
            },
            1200: {
              items: 7
            }
          }
        });
      }
    } else {
      $('.owl-carousel-7').owlCarousel({
        loop: false,
        nav: true,
        margin: 16,
        responsiveClass: true,
        dots: false,
        navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 3
          },
          1024: {
            items: 5
          },
          1200: {
            items: 7
          }
        },
        onDragged: (e) => {
          $('.mobile-day').css('border', '1px solid #ECECEC');
          $(`#${e.item.index + 1}-mobile-day`).css('border', '2px solid #10559A');
          this.calendarFocusable();
        }
      });
    }
  },

  /**
  * show/hide selected mark
  * @param {CustomEvent} e
  */
  showSelected(e) {
    const { currentTarget } = e;
    $(currentTarget).find('.c-table-time').hide();
    $(currentTarget).find('.c-table-price').hide();
    $(currentTarget).find('.loading-cart').css('display', 'flex');

    // TODO - need to write ajax POST data request here
    if (!$(currentTarget).hasClass('selected')) {
      let currentTreatment;
      $.each(this.jsonData.availability.guestData.days, (index, value) => {
        if (value.treatments.filter((x) => x.uniqueId === currentTarget.id).length) {
          currentTreatment = value.treatments.filter((x) => x.uniqueId === currentTarget.id);
        }
      });
      // Preparing ajax data object for POST request
      const ajaxData = {
        productCodePost: currentTreatment[0].id,
        CSRFToken: $('#csrfSessionToken').data('csrf'),
        spaProductPrice: currentTreatment[0].price.value,
        quantity: 1,
        spaServiceDuration: currentTreatment[0].duration,
        spaServiceDate: this.formatDate(currentTreatment[0].time),
        spaServiceTime: this.formatTime(currentTreatment[0].time),
        spaBundleEligible: currentTreatment[0].bundleEligible.toString(),
        resHoldId: currentTreatment[0].resHoldId,
        spaGuestId: `${this.currentUserId}`
      };
      const pageType = $('#pagetype').data('pagetype');
      ajaxData.pageType = pageType;
      if (pageType === 'CATEGORY') {
        ajaxData.productPosition = localStorage.getItem('productposition');
        ajaxData.pageNumber = localStorage.getItem('pageNumber');
        ajaxData.categoryName = localStorage.getItem('sascategorycode');
      }
      $.ajax({
        type: 'POST',
        url: '/shop/cart/add',
        data: ajaxData
      }).done((response) => {
        if (response.addedToCart) {

          // Below if block is for YMALT carousel
          if ($('body').find('.cart-carousel').length) {
            $('#calendarHtml .close').addClass('refresh-window');
            $('#calendarHtml .modal').attr('data-keyboard', 'false');
          } else if ($('body').find('.pdp-carousel').length) {
            $('#calendarHtml .modal').attr('data-keyboard', 'false');
            $('#calendarHtml .close').addClass('reload-carousel');
          }
          $('#spaAddedAlert').empty().append(`<span role='alert'>Item Added To cart</span>`);
          $(currentTarget).addClass('selected');
          $(currentTarget).attr('aria-Label', `price ${currentTarget.dataset.price} already added to cart`);
          $(currentTarget).find('.close').show();
          $(currentTarget).find('.loading-cart').hide();
          if (Number(currentTreatment[0].duration) >= 45) {
            $(currentTarget).find('.c-table-time').show();
          }
          $(currentTarget).find('.c-table-price').show();
          this.prepareData(currentTarget.id, 'add');
          gfunctions.updateHeaderCartWidget(response);
        } else {
          gfunctions.showToast('#snackbar', 4000);
        }

      }).fail(() => {
        console.log('Something went wrong');
        gfunctions.showToast('#snackbar', 4000);
        $(currentTarget).find('.loading-cart').hide();
        if (Number(currentTreatment[0].duration) >= 45) {
          $(currentTarget).find('.c-table-time').show();
        }
        $(currentTarget).find('.c-table-price').show();
        $(currentTarget).removeClass('selected');
        $(currentTarget).find('.close').hide();
      });
    }
  },

  formatDate(date) {
    const today = new Date(date);
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd}-${mm}-${yyyy}`;
  },

  formatTime(time) {
    const today = new Date(time);
    let hours = today.getHours();
    let min = today.getMinutes();
    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (min < 10) {
      min = `0${min}`;
    }
    return `${hours}:${min}`;
  },

  /**
   * Prepare ajax data
   * @param {String} id
   * @param {String} action
   */
  prepareData(id, action) {
    $.each(this.jsonData.availability.guestData.days, (i, v) => {
      if (v.treatments.filter((x) => x.uniqueId === id).length) {
        if (action === 'add') {
          v.treatments.filter((x) => x.uniqueId === id)[0].addedTocart = true;
          v.hasSelectedTimings = true;
          this.showGreenDot(v.id, 'add');
        } else {
          v.treatments.filter((x) => x.uniqueId === id)[0].addedTocart = false;
          if (v.treatments.some((time) => time.addedTocart)) {
            v.hasSelectedTimings = true;
            this.showGreenDot(v.id, 'add');
          } else {
            v.hasSelectedTimings = false;
            this.showGreenDot(v.id, 'remove');
          }
        }
      }
    });
    this.disableEnableCheckoutBtn();
  },

  /**
  * Disable or enable checkout btn
  */
  disableEnableCheckoutBtn() {
    const temp = [];
    $.each(this.jsonData.availability.guestData.days, (i, v) => {
      if (v.treatments.some((x) => x.addedTocart)) {
        temp.push(true);
      }
    });
    // check if anything is added in cart then change checkout button
    if (temp.some((x) => x)) {
      $('#checkoutButton').removeAttr('disabled');
    } else {
      $('#checkoutButton').prop('disabled', true);
    }
  },

  /**
  * show/hide selected mark
  * @param {CustomEvent} e
  * @param {String} action
  */
  showGreenDot(id, action) {
    const mobileDayElement = $(`#${id}-mobile-day`);
    const desktopDayElement = $(`#${id}-day`);
    if (action === 'add') {
      if (!mobileDayElement.hasClass('mobile-green-dot')) {
        mobileDayElement.addClass('mobile-green-dot');
        const MobLabel = $($(`#${id}-mobile-day`)[0].firstElementChild).attr('aria-label');
        $($(`#${id}-mobile-day`)[0].firstElementChild).attr('aria-label', `${MobLabel} has selected slots`);
      }
      if (!desktopDayElement.hasClass('has-selected-times')) {
        desktopDayElement.addClass('has-selected-times');
        const label = $($(`#${id}-day`)[0].previousElementSibling.previousElementSibling).attr('aria-label');
        $($(`#${id}-day`)[0].previousElementSibling.previousElementSibling).attr('aria-label', `${label} has selected slots`);
      }
    } else {
      mobileDayElement.removeClass('mobile-green-dot');
      desktopDayElement.removeClass('has-selected-times');
      let label2 = $($(`#${id}-day`)[0].previousElementSibling.previousElementSibling).attr('aria-label');
      const finalLabel = label2.replace('has', '')
        .replace('selected', '')
        .replace('slots', '');
      $($(`#${id}-day`)[0].previousElementSibling.previousElementSibling).attr('aria-label', finalLabel);
    }
  },

  toggleDepartureTime() {
    //  $('.departure-link').each((index, element) => {
    $('body').on('click keypress', '.departure-link', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        $('.departure-link').toggleClass('open');
        const targetElement = $(event.target).parents('.c-pdp-card').find('.departure-dropdown');
        if ($('.departure-link').hasClass('open')) {
          $('.departure-link a').attr('aria-label', 'View departure time expanded');
        } else {
          $('.departure-link a').attr('aria-label', 'View departure time collapsed');
        }
        $(targetElement).slideToggle();
        $('.departure-link a').addClass('ada-highlighted');
        setTimeout(() => {
          $('.departure-link a').focus();
        }, 400);
      }
    });
  },

  toggleWheelChair() {
    $('body').on('click keypress', '.wheel-chair-arrow0', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        const expanded = $(event.currentTarget).attr('aria-expanded');
        console.log(expanded);
        $('.wheel-chair-arrow0').toggleClass('open');
        const targetElement = $(event.target).parents('.c-pdp-card').find('.wheel-chair0 .wheel-chair-content');
        console.log('targetElement : ', $(targetElement));
        $(targetElement).slideToggle();
        if (expanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      }
    });
    // });
  },

  toggleSpecialService() {
    $('#wheel-chair1')[0].checked = true;
    // $('.wheel-chair-arrow1').each((index, element) => {
    $('body').on('click keypress', '.wheel-chair-arrow1', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        const expanded = $(event.currentTarget).attr('aria-expanded');
        console.log(expanded);
        $('.wheel-chair-arrow1').toggleClass('open');
        const targetElement = $(event.target).parents('.c-pdp-card').find('.wheel-chair1 .wheel-chair-content');
        $(targetElement).slideToggle();
        if (expanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      }
    });
    // });
  },

  toggleBookingDropdown() {
    $('body').on('click keypress', '.booking-toggle', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $(event.currentTarget.lastElementChild).toggleClass('open');
        // const targetElement = $(event.target).parents('.c-pdp-card').find('.booking-dropdown');
        $(event.currentTarget.nextElementSibling).slideToggle();
        const ariaExpanded = $(event.currentTarget).attr('aria-expanded');
        if (ariaExpanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      }
    });
  },
  scrollToReviews() {
    $('.c-pdp-card .details-rating').on('click', () => {
      $('html, body').animate({
        scrollTop: $('#BVRRSearchContainer').offset().top
      }, 1200);
    });
    $(window).on('load', () => {
      $.ready.then(() => {
        // Both ready and loaded
        const tScroll = deloitteCookies.get('scrollToTarget');
        if (tScroll) {
          const tDiv = `#${tScroll}`;
          const scrollValue = $(tDiv).offset().top;
          if (tScroll) {
            $('html, body').animate({
              scrollTop: scrollValue
            }, 1200);
            deloitteCookies.remove('scrollToTarget');
          }
        }
      });
    });
  },
  toReviews() {
    $('.c-product-card .rating, .c-product-card .be-first-to-review').on('click', (event) => {
      const scrollToTarget = $(event.currentTarget).data('scroll');
      deloitteCookies.set('scrollToTarget', scrollToTarget);
    });
  },

  modalEvents() {
    const modalEl = $('#calendarModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');
    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  },

  calendarModalEvents() {
    $('#calendarModal').on('shown.bs.modal', function (e) {
      const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
      if (isOnIOS && isOnIOS.length && (!CCL.pdpCard.calendarError && !CCL.pdpCard.isCruisePass)) {
        // if (!this.calendarError || !this.isCruisePass) {
        $('body.modal-open').addClass('position-fixed-style');
      }
    });
    $('#calendarModal').on('hide.bs.modal', function (e) {
      const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
      if (isOnIOS && isOnIOS.length && (!CCL.pdpCard.calendarError && !CCL.pdpCard.isCruisePass)) {
        // if (!this.calendarError || !this.isCruisePass) {
        $('body.modal-open').removeClass('position-fixed-style');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-pdp-card/pdp-card.js